<template>
    <a-modal v-bind:open="computedShowModal"
        width="720px"
        :closable="true"
        :footer="null"
        :mask-closable="false"
        :mask-style="{backdropFilter: 'blur(2px)'}"
        :keyboard="false"
        title="제품 정보 수정"
        :centered="true"
        @cancel="closeModal"
    >
        <div class="modal-content-body">
            <div class="modal-input-area">
                <div class="label-wrap">
                    <i class="fa-solid fa-barcode-read"/>
                    <label>품목코드
                        <span class="required-span"/>
                    </label>
                </div>
                <a-select 
                    v-model:value="selectedItem" 
                    @change="onChangeItem" 
                    class="content-part"
                    placeholder="품목을 선택해 주세요."
                    :not-found-content="null"
                    :defaultActiveFirstOptio="true"
                >
                    <a-select-option 
                        v-for="item in itemsList" 
                        :value="item._id" 
                        :key="item._id"
                    >
                        {{ `${item.itemName} / ${item.itemCode}` }}
                    </a-select-option>
                </a-select>
            </div>
            <div class="modal-input-area">
                <div class="label-wrap">
                <i class="fa-solid fa-barcode-read"/>
                <label>제품코드
                    <span class="required-span"/>
                </label>
                </div>
                <a-input
                    v-model:value="productDetailData.productCode" 
                    placeholder="제품 코드를 입력하세요" 
                />
            </div>
            <div class="modal-input-area align-top">
                <div class="label-wrap label-wrap-align-top">
                    <i class="fa-light fa-message-lines"/>
                    <label>제품설명</label>
                </div>
                <a-textarea 
                    v-model:value="productDetailData.description" 
                    placeholder="제품 설명을 입력하세요"
                />
            </div>
        </div>
        <div class="modal-footer">
            <a-button
                @click="closeModal"
            >
                취소
            </a-button>
            <a-button
                type="primary"
                @click="validate"
            >
                수정
            </a-button>
        </div>
    </a-modal>
</template>
<script>
    import { oneBtnDialog } from '@/utils/utils';
    import { modalType } from '../enums/enums';

    export default {
        data() {
            return {
                selectedItem: undefined,
                itemsList: [],
                productDetailData: {
                    itemName: '',
                    itemCode: '',
                    itemNo: '',
                    description: '',
                    productId: '',
                    productCode: '',
                    jsonContents: [],
                },
            };
        },
        props: {
            showModal: {
                type: Boolean,
                required: true,
                default: false,
            },
            id: {
                type: String,
                reqiured: true,
                default: '',
            },
        },
        async mounted() {
            await this.getItems();
        },
        emits: ['closeModal', 'getProductsList',],
        computed: {
            computedShowModal() {
                return this.showModal;
            },
        },
        watch: {
            id: {
                immediate: true,
                deep: true,
                handler(newValue, oldValue) {
                    if(newValue) {
                        console.log('newValue')
                        this.getProductDetail(newValue);
                    } 
                },
            },
        },
        methods: {
            closeModal() {
                this.$emit('closeModal', modalType.modify, false);
                this.$emit('getProductsList');
            },
            async getProductDetail(productId) {
                try {
                    const response = await this.$apiInstance.get(`/products/${productId}`);
                    if (response.status === 200 || response.status === 201) {
                    this.productDetailData = response.data;
                    this.selectedItem = response.data.itemId;
                    this.productDetailData.productId = productId;
                    }
                } catch (error) {
                    console.log(error);
                    oneBtnDialog('제품 정보 로드 실패', '제품 정보 로드에 실패하였습니다.', false);
                }
            },
            // 업로드 전 검증
            async validate() {
                if (this.productDetailData.productCode !== '') {
                    this.updateProduct();
                } else {
                    await oneBtnDialog('제품코드 미입력', '제품코드는 필수입니다.', false);
                }
            },

            // 품목 가져오기
            async getItems() {
                try {
                    const response = await this.$apiInstance.get(`/products/item/list`);
                    if (response.status === 200 || response.status === 201) {
                        this.itemsList = response.data;
                    }
                    console.log('getItems')
                } catch(error) {
                    console.log(error);
                    await oneBtnDialog('품목 목록 로드 실패', '품목 목록 로드에 실패하였습니다', false);
                }
            },
            onChangeItem(event) {
                const result = this.itemsList.find(item => item._id === event)
                if(result) {
                    this.productDetailData.description = result.description;
                } else {
                    this.productDetailData.description = '';
                }
            },
            // 제품 업데이트
            async updateProduct() {
                const obj = {};
                if (this.selectedItem) obj.itemId = this.selectedItem; // 품목코드 
                if (this.productDetailData.productCode) obj.productCode = this.productDetailData.productCode;
                if(this.productDetailData.description) {
                    obj.description = this.productDetailData.description;
                } else {
                    obj.description = '';
                }

                try {
                    const response = await this.$apiInstance.put(`/products/${this.id}`, obj);
                    if (response.status === 200 || response.status === 201) {
                    await oneBtnDialog('제품 정보 수정 완료', '제품 정보 수정이 완료되었습니다.', false);
                    this.closeModal();
                    }
                } catch(error) {
                    console.log(error);
                    if(error.response && error.response.status === 400) {
                    await oneBtnDialog('제품 코드 중복', '존재하는 제품 코드입니다.', false);
                    } else {
                    await oneBtnDialog('제품 정보 수정 실패', '제품 정보 수정에 실패하였습니다.', false);
                    }
                }
            },
        },
    };
</script>
<style lang="scss" scoped>

$Gray-10: #F3F5F6;
$Gray-20: #e8ebed;
$Gray-50: #ACB2B9;
$Gray-60: #8D939A;
$Gray-70: #6e747c;
$Gray-80: #4B5158;
$Gray-90: #2F3337;
$Gray-100 : #17191C;
$CertiLifeYellow: #ffe414;

.modal-content-body {
    padding: 20px;
}

.modal-input-area {
    display: flex;
    // justify-content: center;
    align-items: center;
    padding: 7px 0;
    width: 100%;

    .content-part {
        width: 80%;
    }

    .infoSpan {
        color: black;
    }

    .label-wrap {
        display: flex;
        align-items: center;
        width: 20%;
        // margin: 0 10px 0 0;
        i {
            margin-right: 5px;
            color: rgb(75, 81, 88);
            font-size: 15px;
        }

        label {
            margin-bottom: 0 !important;
            color: rgb(75, 81, 88);
            font-size: 15px;
            font-weight: 500;
            text-align: start;
            display: flex;
            .required-span {
                width: 6px;
                height: 6px;
                border-radius: 100%;
                background-color: #FB574B;
                margin-left: 3px;
                display: block;
                margin-top: 2px;
            }
        }
    }

    .label-wrap-align-top {
        padding-top: 15px !important;
    }

    select {
        width: 80%;
        border-radius: 6px;
        border: solid 1px rgba(0, 0, 0, 0.2);
        height: 40px;
    }

    textarea {
        width: 80%;
        border-radius: 6px;
        border: solid 1px rgba(0, 0, 0, 0.2);
        height: 100px;
        resize: none;
        padding: 7px 14px;
        &:disabled {
            background-color: $Gray-10;
        }
    }

    // 제품정보보기
    .props-wrap {
        width: 80%;
        // border-radius: 5px;
        // border: solid 1px rgba(0, 0, 0, 0.2);
        // height: 100px;
        // resize: none;
    }

    .prop {
        width: 100%; 
        display: flex;
    }

    .json-key {
        display:flex;
        flex-direction: column; 
        margin-right: 2.5%; 
        width: 47.5%;
    }

    .json-value {
        display:flex;
        flex-direction: column; 
        margin-left: 2.5%; 
        width: 47.5%;
    }





    .selectWrap {
        width: 80%;
        display: flex;
        justify-content: space-between;

        select {
            width: 40%;
        }
    }

    .newLabel {
        width: 20%;
        // width: 30%;
        margin: 0 10px 0 0;
        color: #111;
        font-size: 15px;
        font-weight: 500;
    }

    input[type=text],
    input[type=password] {
        width: 80%;
        border-radius: 6px;
        border: solid 1px rgba(0, 0, 0, 0.2);
        height: 40px;
        padding: 0 14px;
        &:disabled {
            background-color: $Gray-10;
        }
    }

    input[type=checkbox] {
        accent-color: #ffd814;
        width: 10px;
    }

    input[type=file] {
        display: none;
    }

    .radioWrap {
        // width: 60%;
        width: 70%;
        display: flex;
        flex-wrap: wrap;
    }

    .radioObj {
        width: auto;
        margin-right: 15px;
        margin-bottom: 5px;

        label {
            width: auto;
            margin-left: 5px;
        }
    }

    .modalBtnRight {
        width: 100%;
        height: 40px;
        justify-content: start;
        align-items: center;
    }

    .modalInputRight {
        padding-left: 20px;
        padding-right: 20px;
        width: 20%;
        display: flex;
        justify-content: start;
        align-items: center;
    }

    // 재직의사 css
    .rowsWrap {
        width: 90% !important;
    }

    .doctorRow {
        display: flex;
        align-items: center;

        .doctorInput {
            width: 75% !important;
        }

        button {
            width: 30px;
            height: 30px;
            margin-left: 10px;
        }
    }


    div {

        input[type="text"] {
            width: 100%;
            margin-top: 5px;
            border-radius: 6px;
        }

        input[type="file"] {
            opacity: 0;
            position: absolute;
            width: 18%;
            right: 8%;
        }

        button {
            background-color: #FFD814;
            padding: 5px 10px;
            border: none;
            border-radius: 8px;
            font-weight: bold;
            font-size: 0.8rem;
            float: right;
        }

        .imgspan {
            font-size: 0.8rem;
            margin-right: 5px;

            img {
                width: 250px;
                margin-bottom: 20px;
            }
        }

        .despan {
            font-size: 0.5rem;
        }

        .yesnospan {
            font-size: 0.9rem;
        }
    }
}

select {
    width: 100%;
}

.modal-input-area:last-child {
    padding: 7px 0 0 0;
}

.modal-footer {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 20px 20px 20px;
    // padding: 20px;
    gap: 10px;
    .button {
        border-radius: 0px;
        color: $Gray-90;
    }
}
</style>